<div>
  <ng-container *ngIf="lineDetails; else showSpinner">
    <div class="row">
      <div class="m-t-xl col-12" *ngIf="imageUrl !== ''">
        <img class="img-fluid" [src]="imageUrl" alt="FPO Image" />
      </div>
      <div class="m-t-xl" [ngClass]="{ 'col-12': isCPS, 'col-9': !isCPS }">
        <p class="lead bold">
          <span *ngIf="lineBillingDetails?.lineDetails?.lineNickname">{{
            lineBillingDetails?.lineDetails?.lineNickname
          }}</span>
        </p>
        <p class="lead bold">
          <span *ngIf="lineDetails?.msisdn">{{ lineDetails?.msisdn | phone }}</span>
        </p>
        <p class="lead" *ngIf="lines && lines?.devicename">{{ lines?.devicename }}</p>
        <ng-container *ngIf="!isCPS">
          <ng-container *ngIf="lineType">
            <p class="small m-t-xs">
              {{ lineBillingDetails?.lineDetails?.productType }} {{ lineType }}
            </p>
          </ng-container>
          <p
            class="small m-t-xs"
            *ngIf="
              lineDetails?.primaryLineIndicator &&
              lineDetails?.primaryLineIndicator === primaryConstant
            "
          >
            {{ contentData?.primary }}
          </p>
          <p class="small m-t-xs" *ngIf="lineDetails?.lineStatus !== 'SUSPENDED'">
            {{ contentData?.lineStatus }}: {{ lineDetails?.lineStatus }}
          </p>
          <p class="small m-t-xs" *ngIf="lineDetails?.lineStatus === 'SUSPENDED'">
            {{ contentData?.lineStatus }}: {{ lineDetails?.lineStatus }} -
            {{ getSubStatus(lineDetails) }}
          </p>
          <a
            [class.disabled]="!isPermissionAvailable || !isUpgradePermissionAvailable"
            href="javascript:void(0)"
            id="upgrade-device-link"
            *ngIf="isLineLandingPage && lineDetails?.lineStatus !== lineStatusCancelled"
            class="small hover-magenta m-t-sm"
            tmoUIPermission
            [targetName]="permissionConstants.CREATE_SCORE_UPGRADE"
            (click)="navigateCheckForLineUpgrade(lineDetails?.lineOfServiceId)"
            >{{ contentData?.upgradeDevice }}
          </a>
        </ng-container>
      </div>
      <!-- Left panel for line details page -->
      <div class="col-12 m-b-lg" *ngIf="isCPS || isLineLandingPage">
        <h5 class="m-t-xl">{{ contentData?.activeServices }}</h5>
        <ng-container *ngIf="lineBillingDetails?.lineDetails?.plan">
          <p class="bold m-t-lg">{{ contentData?.plan }}</p>
          <p class="m-t-xs" [ngClass]="{ 'alert-text': !newPlan }" id="active-plan">
            <i class="fa fa-check def alert-icon"></i>
            {{ lineBillingDetails?.lineDetails?.plan?.name }}
          </p>
          <div [hidden]="true" id="active-plan-value">
            {{ lineBillingDetails?.lineDetails?.plan?.price }}
          </div>
        </ng-container>
        <ng-container *ngIf="lineBillingDetails?.lineDetails?.services?.length">
          <p class="bold m-t-lg">{{ contentData?.services }}</p>
          <p
            class="m-t-xs alert-text"
            *ngFor="let service of lineBillingDetails?.lineDetails?.services; let i = index"
            id="active-services-{{ i }}"
          >
            <i class="fa fa-check def alert-icon"></i>{{ service?.name }}
          </p>
        </ng-container>
        <ng-container *ngIf="thirdPartyServiceArray?.length > 0">
          <p class="bold m-t-lg">{{ contentData?.thirdPartyServices }}</p>
          <p
            class="m-t-xs alert-text"
            *ngFor="let thirdPartyService of thirdPartyServiceArray; let i = index"
            id="third-party-services-{{ i }}"
          >
            <i class="fa fa-check def alert-icon"></i>{{ thirdPartyService?.name }}
          </p>
        </ng-container>

        <ng-container *ngIf="lineSessionPassDetails?.lineDetails?.passDetails?.active?.length">
          <p class="bold m-t-lg" id="session-pass">{{ contentData?.onDemandPasses }}</p>
          <p
            class="m-t-xs alert-text"
            *ngFor="
              let dataPass of lineSessionPassDetails?.lineDetails?.passDetails?.active;
              let i = index
            "
            id="session-passes-{{ i }}"
          >
            <i class="fa fa-check def alert-icon"></i>{{ dataPass?.passName }}
          </p>
        </ng-container>
        <p
          class="m-t-lg"
          *ngIf="
            lineSessionPassDetails?.lineDetails?.pending?.plan?.length > 0 ||
            lineSessionPassDetails?.lineDetails?.pending?.service?.length > 0
          "
        >
          <a href="javascript:void(0)" id="cta-default-23">{{
            contentData?.accountLandingButtonText
          }}</a>
        </p>
      </div>
      <div class="col-12">
        <a
          *ngIf="futureProductsAvailable; else noFutureProducts"
          href="javascript:void(0)"
          (click)="openActiveProductsModal($event)"
          id="view-active-future-products"
          >{{ contentData?.viewActiveAndFutureProducts }}</a
        >
        <ng-template #noFutureProducts>
          <a
            href="javascript:void(0)"
            (click)="openActiveProductsModal($event)"
            id="view-active-products"
            >{{ contentData?.viewActiveProducts }}</a
          >
        </ng-template>
        <p class="m-t-lg m-b-lg bold" *ngIf="!isManagePendingOrderPage && pendingOrdersCount">
          {{ pendingOrdersCount }}
        </p>
      </div>
    </div>
  </ng-container>
  <ng-template #showSpinner>
    <div class="row">
      <div class="col-12 text-center">
        <i class="fa fa-spinner fa-pulse spinner-icon"></i>
      </div>
    </div>
  </ng-template>

  <tmo-dynamic-modal [modal]="sendPlanModal" #dynamicModal *ngIf="isCPS">
    <!-- @TODO Will be done as a part of US237584-->
    <ng-container header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo"></i>
        <button
          [attr.aria-label]="contentData?.clickToClose"
          id="close-button"
          class="close-x model-close-btn"
          (click)="closeModal()"
          tabindex="0"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </ng-container>
  </tmo-dynamic-modal>
  <ng-template #showSpinner>
    <div class="row">
      <div class="col-12 text-center">
        <i class="fa fa-spinner fa-pulse spinner-icon"></i>
      </div>
    </div>
  </ng-template>

  <tmo-dynamic-modal [modal]="sendPlanModal" #dynamicModal *ngIf="isCPS">
    <!-- @TODO Will be done as a part of US237584-->
    <ng-container header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo"></i>
        <button
          [attr.aria-label]="contentData?.clickToClose"
          class="close-x model-close-btn"
          (click)="closeModal()"
          tabindex="0"
          id="btn-default-70"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="row">
        <div class="col-8">
          <h3>{{ selectedPlan?.description }}</h3>
        </div>
        <div class="col-4 p-t-md m-t-sm text-end">
          <p class="lead">{{ selectedPlan?.price | currency: 'USD' : 'symbol-narrow' }}</p>
          <p class="xsmall">{{ contentData?.perMonth }}</p>
        </div>
        <!-- <div class="col-12 m-t-sm" *ngIf="isAssistedFlow">
          <p class="small">({{contentData?.offerCode}}: {{selectedPlan?.code}})</p>
        </div> -->
      </div>
    </ng-container>
    <p class="lead bold">{{ contentData?.planDescription }}</p>
    <p class="small m-t-sm">{{ selectedPlan?.longDescription }}</p>
    <p class="legal m-t-xl">{{ contentData?.legalText }}</p>
  </tmo-dynamic-modal>
  <tmo-dynamic-modal [modal]="activeProductsModal" #dynamicModal *ngIf="contentData">
    <ng-container header>
      <div class="modal-logo-close">
        <i class="logo-icon t-icon t-icon-logo"></i>
        <a
          href="javascript:void(0)"
          [attr.aria-label]="contentData?.clickToClose"
          id="close-modal"
          class="close-x pull-right"
          (click)="closeModal()"
          ><i class="fa fa-times"></i
        ></a>
      </div>
      <h3 class="m-t-md">{{ contentData?.lineDetails }}</h3>
    </ng-container>
    <ng-container *ngIf="customerBillingDetails">
      <tmo-monthly-charges
        [customerAccountBillingDetails]="customerBillingDetails"
        [contentData]="contentData"
        [showOnLineDetails]="true"
      ></tmo-monthly-charges>
    </ng-container>
    <ng-container>
      <tmo-one-time-charges
        [lineUsageSummary]="lineUsage"
        [passDetails]="lineSessionPassDetails?.lineDetails?.passDetails"
        [contentData]="contentData"
        [showOnLineDetails]="true"
      ></tmo-one-time-charges>
    </ng-container>
    <!-- Starts pending orders section-->
    <ng-container *ngIf="linePendingOrdersModel?.ordersByType?.length > 0 && selectedOption">
      <div class="row n-p">
        <div class="col-12 m-t-xl">
          <h4 class="title">{{ contentData?.pendingOrdersHeader }}</h4>
        </div>
      </div>
      <p class="m-t-lg" *ngIf="pendingOrdersCount">{{ pendingOrdersCount }}</p>

      <div class="row" *ngFor="let order of linePendingOrdersModel?.ordersByType">
        <div class="col-12">
          <p class="bold m-t-md">{{ order?.label }} ({{ order?.value?.length }})</p>
        </div>
        <div class="col-12" *ngFor="let orderType of order?.value">
          <label class="form-label m-t-md">
            <tmo-radio-button
              [id]="pending - order - radio"
              [name]="contentData?.order"
              [aria-label]="orderType?.orderId"
              [selectedValue]="selectedOption"
              (onSelect)="onSelect(orderType?.orderId)"
              [values]="orderType?.orderId"
            >
              <p class="content">{{ contentData?.order }}# {{ orderType?.orderId }}</p>
            </tmo-radio-button>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-12 buttons-container button-spacing">
          <div class="button-box">
            <button
              class="btn btn-primary"
              [attr.aria-label]="contentData?.viewPendingOrders"
              id="view-pending-orders-cta"
              (click)="goToOrderSummary()"
            >
              {{ contentData?.viewPendingOrders }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </tmo-dynamic-modal>
  <hr class="divider d-md-none" />
</div>
